import { CommonAlertService } from './../../services/common-alert.service';
import { filter } from 'rxjs/operators';
import { MasterService } from './../../home/services/master.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgForm, Form } from '@angular/forms';

@Component({
  selector: 'app-bodyparts-modal',
  templateUrl: './bodyparts-modal.component.html',
  styleUrls: ['./bodyparts-modal.component.scss']
})
export class BodypartsModalComponent implements OnInit {

  editOb: any;
  editData: any;
  nameID: any;
  public user = {
    name : '',
    type : ''
  };
  successMsg: any;
  public editPermission = false;
  // tslint:disable-next-line:max-line-length
  constructor(public dialogRef: MatDialogRef<BodypartsModalComponent>, public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {

    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.body_parts.edit'] == 1) {
        this.editPermission = true;
      }
    }

    if (this.editOb) {
      this.masterService.getRecordById(this.editOb.editID, this.editOb.encryId, '/body_parts/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data;
      });
    }

  }

    submitForm() {
    if (this.editData) {
      // tslint:disable-next-line:no-shadowed-variable variable-name
      const form_data = {};
      Object.assign(form_data, {
        token: localStorage.getItem('token'),
        id: this.editOb.editID,
        name: this.editData.name,
        type: this.editData.type
      });
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/body_parts/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });
      this.close();
    } else {
      // tslint:disable-next-line:variable-name
      const form_data = {};

      Object.assign(form_data, {
        token: localStorage.getItem('token'),
        name: this.user.name,
        type: this.user.type
      });
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/body_parts/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
